<template>
	<div class="trm-timer">
	    <div class="trm-timer-val day" v-if="timeUntil.day >= 0"><span>{{ timeUntil.day | pad }}</span> <span>day{{ timeUntil.day > 1 ? `s` : `` }}</span></div>
	    <div class="trm-timer-val hour" v-if="timeUntil.hour >= 0"><span>{{ timeUntil.hour | pad }}</span> <span>hour{{ timeUntil.hour > 1 ? `s` : `` }}</span></div>
	    <div class="trm-timer-val minute" v-if="timeUntil.minute >= 0"><span>{{ timeUntil.minute | pad }}</span> <span>min{{ timeUntil.minute > 1 ? `s` : `` }}</span></div>
	    <div class="trm-timer-val second" v-if="timeUntil.second >= 0"><span>{{ timeUntil.second | pad }}</span> <span>sec{{ timeUntil.second > 1 ? `s` : `` }}</span></div>
	    <span v-else>00:00:00:00</span>		
	</div>
</template>

<script>
export default {
	name: 'timer',
	data () {
		return {
			interval: null,
			timeUntil: {}
		};
	},

	props: {
		target: Number
	},

	mounted () {
		this.tick();
		this.interval = setInterval(this.tick, (1 * 1000));
	},

	methods: {
		tick () {
			this.calculateTimeRemaining();
		},

		calculateTimeRemaining () {
			this.timeUntil = {};

			if (this.$root.marathon.starts_unix === 0)
				return;

			var currentUnixTimestamp = (new Date().getTime() / 1000);
			var targetUnixTimestamp = (this.target | this.$root.marathon.starts_unix);

			var timeRemaining = Math.floor(Math.abs(currentUnixTimestamp - targetUnixTimestamp));
			if (timeRemaining === 0)
				return;

			var snowman = {
				day: 86400,
				hour: 3600,
				minute: 60,
				second: 1
			};

			var self = this;
			Object.keys(snowman).forEach((key) => {
				self.timeUntil[key] = Math.floor(timeRemaining / snowman[key]);
				timeRemaining -= (self.timeUntil[key] * snowman[key]);
			});
		}
	},

	filters: {
		pad (val) {
			if (val < 10)
				return "0" + val;

			return val;
		}
	}
}
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// Timer.vue?10767302